export default {
  init() {
    forceSelect2Fields();
  },
  finalize() {
  },
};

export var forceSelect2Fields = () => {
  let $countryFields = $('#preferred_shoe_size, #billing_country, #preferred_store');

  $countryFields.each(function() {
    let $this = $(this);

    if ($this.length > 0 && $this.is('select') && !$this.next('.select2-container').length) {
      if (typeof $.fn.selectWoo !== 'undefined') {
        $this.selectWoo({ width: '100%' });
      } else if (typeof $.fn.select2 !== 'undefined') {
        $this.select2({ width: '100%' });
      }
    }
  });
};
